import Admin from "./layouts/Admin.js";
import LoginForm from "./layouts/Login.js";
import { Route, BrowserRouter as Router, Routes, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import { useSelector } from "react-redux";
import {
  selectCurrentToken,
  selectCurrentUser,
} from "./features/auth/authSlice";
import PublicInvoice from "./views/common/invoice.js";
// console.log(selectCurrentToken, selectCurrentUser);
function App() {
  // const user = useSelector(selectCurrentUser);
  // const token = useSelector(selectCurrentToken);
  const themeColor = process.env.REACT_APP_THEME_COLOR || "light";
  return (
    <div className={`theme-${themeColor}`}>
      <Router>
        <AppRoutes />
      </Router>
    </div>
  );
}


function AppRoutes() {
  const location = useLocation(); // Get the current location (URL)
  const user = useSelector(selectCurrentUser); // Get the current user from Redux
  const token = useSelector(selectCurrentToken); // Get the current token from Redux
  const isDownloadRoute = location.pathname.includes("/common"); // Check if the URL contains 'download'
  return (
    <>
      {isDownloadRoute && (
        <>
          <Routes>
            <Route path="/common/invoices/:id" element={<PublicInvoice />} />
          </Routes>
        </>
      )}
      {!isDownloadRoute && (
        <>
          {!user && !token && <LoginForm />}
          {user && token && <Admin />}
        </>
      )}
    </>
  );
}

export default App;
